<template>
  <AppModalEdit
    v-model="isActive"
    :confirm-on-click-cancel="false"
    @clickExec="onClickExec"
    @clickCancel="onClickCancel"
    title="配信先設定 > ブラックリスト > 任意設定"
    exec-button-text="保存"
  >
    <div class="default-inventory-list-btn">
      <v-btn @click="onClickReset" :disabled="isDisabledReset"
        >推奨設定に戻す</v-btn
      >
    </div>
    <AppTwoColumnsSelector
      :items="inventoryListsAll"
      :value="resultInventoryLists"
      :reject-permitter="rejectPermitter"
      :is-disabled="isDisabled"
      @changeChosenItems="onChangeInventoryList"
      available-label="配信先リスト一覧"
      chosen-label="配信先設定一覧"
      item-value="id"
    />
  </AppModalEdit>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    list: {
      // idの配列
      type: Array,
      default: () => [],
    },
    inventoryListsAll: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      resultInventoryLists: [],
      loadingInventoryLists: true,
    }
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    isDisabledReset() {
      return (
        JSON.stringify(
          this.inventoryListsAll
            .filter(item => item.usePolicy === 'recommended')
            .map(item => item.id)
            .sort(),
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        ) === JSON.stringify(this.resultInventoryLists.sort())
      )
    },
  },
  watch: {
    list(newVal) {
      this.resultInventoryLists = newVal
    },
  },
  created() {
    this.resultInventoryLists = this.list
    console.log()
  },
  methods: {
    // requiredのリストは取り外せないようにする
    rejectPermitter(item) {
      if (item.usePolicy === 'required') {
        this.$confirm(`${item.name} リストは必ず配信先から除外設定されます。`, {
          onlyOk: true,
          okText: '閉じる',
        })
        return false
      }
      return true
    },
    // 非活性の項目を判定する
    isDisabled(item) {
      if (item.usePolicy === 'required') return true
      return false
    },
    onChangeInventoryList(items) {
      this.resultInventoryLists = items
    },
    onClickExec() {
      this.$emit('change', this.resultInventoryLists)
      this.isActive = false
    },
    onClickCancel() {
      this.resultInventoryLists = this.list
    },
    async onClickReset() {
      const result = await this.$confirm('確認', {
        body:
          'ブラックリストの任意設定が初期化されますが、よろしいでしょうか？',
        okText: '推奨設定に戻す',
        cancelText: 'キャンセル',
      })
      if (result) {
        this.resultInventoryLists = this.inventoryListsAll
          .filter(item => item.usePolicy === 'recommended')
          .map(item => item.id)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.default-inventory-list-btn {
  margin: 20px 0 20px 0;
  text-align: end;
}
.select-list-height {
  height: 300px;
}
</style>
